/* Converted to vanilla JS
   Original: Jonathan Snook - prepareTransition + jQuery-based wayfx file
   Notes: Replaced jQuery with modern browser APIs. Keep an eye on third-party globals (Shopify, sitewide, window.GlobalCartMain).
*/

/* prepareTransition (vanilla) */
(function () {
  if (!Element.prototype.prepareTransition) {
    Element.prototype.prepareTransition = function () {
      var el = this;
      var styles = window.getComputedStyle(el);
      var durationProps = ['transitionDuration', 'WebkitTransitionDuration', 'MozTransitionDuration', 'OTransitionDuration'];
      var d = 0;
      durationProps.forEach(function (prop) {
        var val = parseFloat(styles[prop]);
        if (!isNaN(val) && val > d) d = val;
      });

      if (d !== 0) {
        el.classList.add('is-transitioning');
        var onEnd = function () {
          el.classList.remove('is-transitioning');
          el.removeEventListener('transitionend', onEnd);
          el.removeEventListener('webkitTransitionEnd', onEnd);
          el.removeEventListener('oTransitionEnd', onEnd);
        };
        el.addEventListener('transitionend', onEnd);
        el.addEventListener('webkitTransitionEnd', onEnd);
        el.addEventListener('oTransitionEnd', onEnd);
        void el.offsetWidth; // force reflow
      }
    };
  }
})();

/*============================================================================
  Money Format - keep as-is (pure JS)
==============================================================================*/
if (typeof Shopify === 'undefined') {
  Shopify = {};
}
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function (cents, format) {
    var value = '',
      placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
      formatString = format || this.money_format;

    if (typeof cents == 'string') {
      cents = cents.replace('.', '');
    }

    function defaultOption(opt, def) {
      return typeof opt == 'undefined' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? decimal + parts[1] : '';

      return dollars + cents;
    }

    let matchResult = formatString.match(placeholderRegex);
    matchResult = matchResult && matchResult[1] ? matchResult[1] : false;
    if (!matchResult) {
      const { shopMoneyFormat, cartCurrencySymbol } = window;
      formatString = shopMoneyFormat ? shopMoneyFormat : cartCurrencySymbol ? `${cartCurrencySymbol}` : false;
      matchResult = formatString.match(placeholderRegex)[1];
    }

    switch (matchResult) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

window.wayfx = window.wayfx || {};

/* Cache selectors (vanilla) */
wayfx.cacheSelectors = function () {
  wayfx.cache = {
    // General
    $html: document.documentElement,
    $body: document.body,

    // Customer Pages
    $recoverPasswordLink: document.querySelector('#RecoverPassword'),
    $hideRecoverPasswordLink: document.querySelector('#HideRecoverPasswordLink'),
    $recoverPasswordForm: document.querySelector('#RecoverPasswordForm'),
    $customerLoginForm: document.querySelector('#CustomerLoginForm'),
    $passwordResetSuccess: document.querySelector('#ResetSuccess'),
  };
};

wayfx.init = function () {
  wayfx.cacheSelectors();
  wayfx.responsiveVideos();
  wayfx.loginForms();
  wayfx.collectionProgress();
};

wayfx.getHash = function () {
  return window.location.hash;
};

wayfx.productPage = function (options) {
  var moneyFormat = options.money_format,
    variant = options.variant,
    selector = options.selector;

  var $productImage = document.querySelector('#ProductPhotoImg'),
    $addToCart = document.querySelector('#AddToCart'),
    $productPrice = document.querySelector('#ProductPrice'),
    $comparePrice = document.querySelector('#ComparePrice'),
    $quantityElements = Array.prototype.slice.call(document.querySelectorAll('.quantity-selector, label + .js-qty')),
    $addToCartText = document.querySelector('#AddToCartText');

  if (variant) {
    if (variant.featured_image) {
      var newImg = variant.featured_image,
        el = $productImage;
      if (Shopify && Shopify.Image && typeof Shopify.Image.switchImage === 'function') {
        Shopify.Image.switchImage(newImg, el, wayfx.switchImage);
      } else {
        wayfx.switchImage(newImg.src || newImg, null, el);
      }
    }

    if (variant.available) {
      $addToCart && $addToCart.classList.remove('disabled');
      if ($addToCart) $addToCart.disabled = false;
      if ($addToCartText) $addToCartText.innerHTML = (window.translations && window.translations['products.product.add_to_cart']) || 'Add to Cart';
      $quantityElements.forEach(function (el) {
        el.style.display = '';
      });
    } else {
      $addToCart && $addToCart.classList.add('disabled');
      if ($addToCart) $addToCart.disabled = true;
      if ($addToCartText) $addToCartText.innerHTML = (window.translations && window.translations['products.product.sold_out']) || 'Sold out';
      $quantityElements.forEach(function (el) {
        el.style.display = 'none';
      });
    }

    if ($productPrice) $productPrice.innerHTML = Shopify.formatMoney(variant.price, moneyFormat);

    if (variant.compare_at_price > variant.price) {
      if ($comparePrice) {
        $comparePrice.innerHTML = ((window.translations && window.translations['products.product.compare_at']) || 'Compare at') + ' ' + Shopify.formatMoney(variant.compare_at_price, moneyFormat);
        $comparePrice.style.display = '';
      }
    } else {
      if ($comparePrice) $comparePrice.style.display = 'none';
    }
  } else {
    $addToCart && $addToCart.classList.add('disabled');
    if ($addToCart) $addToCart.disabled = true;
    if ($addToCartText) $addToCartText.innerHTML = (window.translations && window.translations['products.product.unavailable']) || 'Unavailable';
    $quantityElements.forEach(function (el) {
      el.style.display = 'none';
    });
  }
};

wayfx.switchImage = function (src, imgObject, el) {
  var element = el instanceof Element ? el : document.querySelector(el);
  if (!element) return;
  element.setAttribute('src', src);
};

wayfx.responsiveVideos = function () {
  var iframes = Array.prototype.slice.call(document.querySelectorAll('iframe[src*="youtube.com/embed"]:not(.no_wrapper), iframe[src*="player.vimeo"]:not(.no_wrapper)'));
  var iframeReset = iframes.concat(Array.prototype.slice.call(document.querySelectorAll('iframe#admin_bar_iframe')));

  iframes.forEach(function (iframe) {
    var wrapper = document.createElement('div');
    wrapper.className = 'video-wrapper';
    iframe.parentNode.insertBefore(wrapper, iframe);
    wrapper.appendChild(iframe);
  });

  iframeReset.forEach(function (iframe) {
    try {
      iframe.src = iframe.src;
    } catch (e) {}
  });
};

wayfx.loginForms = function () {
  function showRecoverPasswordForm() {
    if (wayfx.cache.$recoverPasswordForm) wayfx.cache.$recoverPasswordForm.style.display = '';
    if (wayfx.cache.$customerLoginForm) wayfx.cache.$customerLoginForm.style.display = 'none';
  }

  function hideRecoverPasswordForm() {
    if (wayfx.cache.$recoverPasswordForm) wayfx.cache.$recoverPasswordForm.style.display = 'none';
    if (wayfx.cache.$customerLoginForm) wayfx.cache.$customerLoginForm.style.display = '';
  }

  if (wayfx.cache.$recoverPasswordLink) {
    wayfx.cache.$recoverPasswordLink.addEventListener('click', function (evt) {
      evt.preventDefault();
      showRecoverPasswordForm();
    });
  }

  if (wayfx.cache.$hideRecoverPasswordLink) {
    wayfx.cache.$hideRecoverPasswordLink.addEventListener('click', function (evt) {
      evt.preventDefault();
      hideRecoverPasswordForm();
    });
  }

  if (wayfx.getHash() === '#recover') {
    showRecoverPasswordForm();
  }
};

wayfx.collectionProgress = function () {
  var collectionProgress = document.querySelectorAll('.js-collection-aov');
  if (!collectionProgress.length) return;

  function update() {
    var header = document.querySelector('.wayfx-header');
    if (!header) return;
    var headerRect = header.getBoundingClientRect();
    var stickyTop = headerRect.height + headerRect.top - 3;

    var messageBar = document.querySelector('.js-below-header-msg-bar');
    if (messageBar) {
      var mRect = messageBar.getBoundingClientRect();
      stickyTop = stickyTop + mRect.height;
    }

    collectionProgress.forEach(function (el) {
      el.style.top = stickyTop + 'px';
    });
  }

  ['load', 'resize', 'scroll'].forEach(function (evt) {
    window.addEventListener(evt, update);
  });
};

wayfx.resetPasswordSuccess = function () {
  if (wayfx.cache.$passwordResetSuccess) wayfx.cache.$passwordResetSuccess.style.display = '';
};

/*============================================================================
  AJAX Add to Cart + builder logic (converted)
==============================================================================*/

// DOM-ready replacements
function onReady(fn) {
  if (document.readyState !== 'loading') {
    fn();
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
}

let isMobile = false;

onReady(function () {
  const mediaQuery = window.matchMedia('(max-width: 768px)');
  handleViewportChange(mediaQuery);
  mediaQuery.addEventListener('change', handleViewportChange);
});

function handleViewportChange(e) {
  isMobile = e.matches;
}

// USED FOR REORDER FUNCTIONALITY ON ORDER HISTORY PAGE
function addToCart(form_id) {
  var form = document.getElementById(form_id);
  if (!form) return;
  var formData = new FormData(form);
  var obj = {};
  formData.forEach(function (value, key) {
    obj[key] = value;
  });

  fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(obj) })
    .then(function (r) {
      return r.json();
    })
    .then(function () {
      addToCartSuccess(form_id);
    })
    .catch(addToCartFail);
}

function addToCartSuccess(product) {
  setTimeout(function () {
    window.GlobalCartMain && window.GlobalCartMain.updateData && window.GlobalCartMain.updateData();
    window.globalSideBarUI__cart && window.globalSideBarUI__cart.open && window.globalSideBarUI__cart.open();
  }, 500);
}

function addToCartFail(obj, status) {
  console.log('Add to Cart Failed...', obj, status);
}
// END

/* Variant selects on grid items */
function updateLabel(_this, variant) {
  /* original async updateLabel; keep call site behavior */
  const currentLabel = _this.closest('form').querySelector('.label-wrapper');
  const selectOption = _this.querySelector(`option[value="${variant}"]`);

  if (currentLabel && selectOption && selectOption.getAttribute('data-label') && selectOption.getAttribute('data-label').includes('label-wrapper')) {
    if (window.sitewide && typeof window.sitewide.updateSelectOptionLabel === 'function') sitewide.updateSelectOptionLabel(variant, selectOption);

    const labelData = selectOption.getAttribute('data-label');
    const labelNode = new DOMParser().parseFromString(labelData, 'text/html');
    if (labelData && labelNode.body.firstChild) currentLabel.replaceWith(labelNode.body.firstChild);
  }
}

function updateOption(_this, variant) {
  const priceElement = _this.querySelector(`option[value="${variant}"]`);
  if (priceElement && priceElement.getAttribute('data-price') && priceElement.getAttribute('data-price').includes('price-v2')) {
    if (window.sitewide && typeof window.sitewide.updateSelectOptionPrice === 'function') return sitewide.updateSelectOptionPrice(variant, priceElement);
  }
}

// wire up select change for variant grids
onReady(function () {
  document.querySelectorAll('.wayfx-product__grid-variant select, .product__grid-variant select').forEach(function (sel) {
    sel.addEventListener('change', async function (e) {
      await Promise.all([updateLabel(sel, e.target.value), updateOption(sel, e.target.value)]);
      var price = sel.querySelector('option:checked') ? sel.querySelector('option:checked').dataset.price : null;
      var priceTarget = sel.parentElement ? sel.parentElement.nextElementSibling : null;
      if (priceTarget && price) priceTarget.innerHTML = price;
    });
  });
});

// simple FAQ and tabs behaviour
onReady(function () {
  document.querySelectorAll('.wayfx-block--faq .wayfx-block--faq__title').forEach(function (title) {
    var parent = title.parentElement;
    var content = title.nextElementSibling;
    if (!content) return;
    parent.classList.toggle('wayfx-block--faq--open', window.getComputedStyle(content).display !== 'none');
    title.addEventListener('click', function () {
      var willOpen = window.getComputedStyle(content).display === 'none';
      parent.classList.toggle('wayfx-block--faq--open', willOpen);
      slideToggle(content, 100);
    });
  });

  document.querySelectorAll('.wayfx-block__tab').forEach(function (tab) {
    tab.addEventListener('click', function () {
      var t = tab.dataset.tab;
      if (!tab.classList.contains('selected')) {
        document.querySelectorAll('.wayfx-block__tab').forEach(function (x) {
          x.classList.remove('selected');
        });
        tab.classList.add('selected');
        if (t === 'login') {
          document.querySelectorAll('.wayfx-block__register-form').forEach(function (f) {
            f.style.display = 'none';
          });
          document.querySelectorAll('.wayfx-block__login-form').forEach(function (f) {
            fadeIn(f, 200);
          });
        } else {
          document.querySelectorAll('.wayfx-block__login-form').forEach(function (f) {
            f.style.display = 'none';
          });
          document.querySelectorAll('.wayfx-block__register-form').forEach(function (f) {
            f.classList.remove('hide-register-form');
            fadeIn(f, 200);
          });
        }
      }
    });
  });

  // initialize wayfx
  wayfx.init();
});

/*============================================================================
Small animation helpers: slideUp / slideDown / slideToggle / fadeIn
==============================================================================*/
function slideUp(el, duration) {
  duration = duration || 200;
  el.style.height = el.offsetHeight + 'px';
  el.style.transitionProperty = 'height, margin, padding';
  el.style.transitionDuration = duration + 'ms';
  el.style.boxSizing = 'border-box';
  el.offsetHeight; // force reflow
  el.style.height = 0;
  setTimeout(function () {
    el.style.display = 'none';
    el.style.removeProperty('height');
    el.style.removeProperty('transition-property');
    el.style.removeProperty('transition-duration');
  }, duration);
}

function slideDown(el, duration) {
  duration = duration || 200;
  el.style.removeProperty('display');
  var display = window.getComputedStyle(el).display;
  if (display === 'none') display = 'block';
  el.style.display = display;
  var height = el.offsetHeight;
  el.style.height = 0;
  el.style.transitionProperty = 'height, margin, padding';
  el.style.transitionDuration = duration + 'ms';
  el.offsetHeight;
  el.style.height = height + 'px';
  setTimeout(function () {
    el.style.removeProperty('height');
    el.style.removeProperty('transition-property');
    el.style.removeProperty('transition-duration');
  }, duration);
}

function slideToggle(el, duration) {
  if (window.getComputedStyle(el).display === 'none') slideDown(el, duration);
  else slideUp(el, duration);
}

function fadeIn(el, duration) {
  duration = duration || 200;
  el.style.opacity = 0;
  el.style.display = '';
  el.style.transition = 'opacity ' + duration + 'ms';
  el.offsetHeight;
  el.style.opacity = 1;
  setTimeout(function () {
    el.style.removeProperty('opacity');
    el.style.removeProperty('transition');
  }, duration);
}
